import api from '../api'

export default {
  computed: {
    api () {
      return api
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/mixins/customGraphApiAware.js